<template>
  <div v-if="!loading && !error">
    <div v-if="data?.Dateien?.Values.length">
      <h3 class="px-4 pt-4">Dateien</h3>
      <v-list lines="two">
        <div v-for="file in data?.Dateien.Values" :key="file.DownloadToken">
          <ApiDownloadItem :file-name="file.Dateiname"
                           :token="file.DownloadToken"
                           :title="file.Dateiname.replaceAll('_', ' ')"
                           :elevation="1"
          />
        </div>
      </v-list>
    </div>

    <div v-if="data?.Unterlagen?.Values.length">
      <h3 class="px-4 pt-4">Unterlagen</h3>

      <v-list>
        <v-list-item
          v-for="item in data?.Unterlagen.Values"
          :key="item.Bezeichnung"
        >

          <v-list-item-title class="mb-2">{{ item.Bezeichnung }}</v-list-item-title>

          <v-row>
            <v-col cols="6" v-for="page in item.Seiten" :key="page.DownloadToken">
              <ApiDownload
                :key="page.Seite"
                :title="`Seite ${page.Seite}`"
                :token="page.DownloadToken"
                :file-name="`${page.Seite.toString()}.jpg`"/>

            </v-col>
          </v-row>


        </v-list-item>
      </v-list>

    </div>
    <v-alert v-if="!data?.Unterlagen?.Values.length && !data?.Dateien?.Values.length" class="mb-0 text-center">
      Es sind keine Dokumente vorhanden
    </v-alert>
    <v-btn
      position="fixed"
      icon
      class="ma-3"
      location="right bottom"

      :to="{ name: 'customer_document_create' }"
      color="primary">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>
  <div v-else-if="error">
    <ErrorDisplay v-if="error" :message="error.message" :loading="loading" @retry="fetchData"/>
  </div>
  <div v-else>
    <Loading/>
  </div>
</template>
<script setup lang="ts">
import {ref} from 'vue';
import ErrorDisplay from '@/components/ErrorDisplay.vue';
import Loading from '@/components/Loading.vue';
import ApiDownload from '@/components/ApiDownload.vue';
import Provider from '@/model/Provider';
import {getProviderDocuments} from '@/api/module/provider';
import {useRoute} from 'vue-router';
import ApiDownloadItem from '@/components/ApiDownloadItem.vue';

const route = useRoute();

const data = ref<Pick<
  Provider,
  | 'Dateien'
  | 'Unterlagen'
  | 'KundStatus'
  | 'Kundname'
  | 'KundenNr'
  | 'icon'
  | 'color'
  | 'GroupName'
> | null>(null);

const loading = ref(true);
const error = ref<Error | null>(null);

async function fetchData() {
  loading.value = true;
  const temp = await getProviderDocuments({
    KundenNr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id),
  });
  loading.value = false;
  data.value = temp[0];
  if (!temp[0]) {
    error.value = new Error('Etwas ist schief gelaufen, versuchen Sie es später');
  }
}

fetchData();

defineExpose({
  fetchData, error, loading, data,
  ErrorDisplay,
  Loading,
  ApiDownload,
});
</script>
